import React, {Fragment} from "react";
import Button from "../Button";
import ChangePurchaseItem, {ProductList} from "../../editors/OperationList/Elements/ChangePurchaseItem";
import {isEqual} from "lodash-es";
import {get, set} from "../../../utils/dotutils";
import debounce from "../../../utils/debounce";
import Portal from "../../layout/Portal";

export default class SwapPayment extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.option || {},
            opened: false
        }
        this.saveChanges = debounce((name, v) => {
            this.props.setFieldValue && this.props.setFieldValue(name, v);
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.option, prevProps.option)) {
            this.setState({
                value: this.props.option
            })
        }
    }

    setFieldValue = (field, value) => {
        return new Promise((resolve) => {
            let oldValue = get(this.state.value, field);
            if (!isEqual(oldValue, value)) {
                const v = {...this.state.value};
                set(v, field, value);
                this.setState({
                    value: v,
                }, () => resolve());
                this.saveChanges(String(this.props.optionIndex), v);
            }
        });
    }

    render() {
        let purchaseitems = this.props.option?.purchaseitems || [];
        const swapPortalId = this.props.swapPortalId || null;
        return (
            <div className="payment swap-payment">
                {swapPortalId ? <Portal portalId={swapPortalId}>
                    {purchaseitems.length ? <Fragment>
                        <label className="control-label">Csere tételek</label>
                        <ProductList purchaseitems={purchaseitems} onItemUpdate={async (item) => {
                            let newPurchaseItems = JSON.parse(JSON.stringify(purchaseitems));
                            const index = newPurchaseItems.findIndex((i) => i.id + "" === "" + item.id);
                            const qty = Math.min(parseFloat(item.pickable_qty), parseFloat(item.qty || "0"));
                            if (index !== -1) {
                                newPurchaseItems[index].qty = qty;
                            } else {
                                item.qty = Math.min(parseFloat(item.pickable_qty), parseFloat(item.qty || "0"));
                                newPurchaseItems.push(item);
                            }
                            newPurchaseItems = newPurchaseItems.filter((item) => parseFloat(item.qty) > 0);
                            await this.setFieldValue("purchaseitems", newPurchaseItems);
                            await this.setFieldValue("amount", Math.round(newPurchaseItems.reduce((sum, item) => sum + parseFloat(item.qty) * parseFloat(item.saleprice), 0)));
                            return true;
                        }} />
                    </Fragment> : null}
                </Portal> : null}
                <Button
                    color="default"
                    block={true}
                    onClick={() => {
                        this.setState({
                            opened: true
                        })
                    }}
                >
                    {
                        purchaseitems.length ?
                            <Fragment>
                                {purchaseitems.length} tétel / {purchaseitems.map((item) => item.qty).reduce((acc, n) => parseFloat(acc || "0") + parseFloat(n || "0"))} darab kiválasztva
                            </Fragment>
                            :
                            <Fragment>
                                Kiválasztás
                            </Fragment>
                    }
                </Button>
                <ChangePurchaseItem
                    selection={purchaseitems}
                    state={this.state.opened}
                    onClose={() => {
                        this.setState({
                            opened: false
                        })
                    }}
                    hide={() => this.setState({opened: false})}
                    setSelected={async (items) => {
                        await this.setFieldValue("purchaseitems", items);
                        await this.setFieldValue("amount", Math.round(items.reduce((sum, item) => sum + parseFloat(item.qty) * parseFloat(item.saleprice), 0)));
                    }}
                />
            </div>
        );
    }
}